"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyShopifyId = void 0;

var abab_1 = require("abab");

var is_base64_1 = __importDefault(require("is-base64"));
/**
 *
 *
 * @export
 * @param {string} id
 * @returns {string}
 */


function getLegacyShopifyId(id) {
  var decodedId = abab_1.atob(id) || '';
  var rawId = is_base64_1.default(id) ? decodedId : id;
  var result = rawId.replace(/^.*\/(\d*)\??.*?$/, '$1');
  return parseInt(result, 10);
}

exports.getLegacyShopifyId = getLegacyShopifyId;